"use client";
// Custom components
import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import Header from "assets/img/search/header.png";
import Token from "assets/img/search/token.png";
import {
  IoArrowUpCircleOutline,
  IoArrowDownCircleOutline,
} from "react-icons/io5";
import { RxEnter } from "react-icons/rx";
import BTC from "assets/img/icons/btc.png";
import BBA from "assets/img/icons/bba.png";

function useOutsideAlerter(ref: any, setX: any): void {
  React.useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    // function handleClickOutside(event: React.MouseEvent<HTMLElement>) {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setX(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setX]);
}

function SearchField(props: {
  id: string;
  extra: string;
  placeholder: string;
  state?: string;
  disabled?: boolean;
  type?: string;
}) {
  const { id, extra, type, placeholder, state, disabled } = props;

  const [dropdownType, setDropdownType] = React.useState("token");
  const [tabIndex, setTabIndex] = useState(0);
  const wrapperRef = React.useRef(null);
  const [openWrapper, setOpenWrapper] = React.useState(false);
  useOutsideAlerter(wrapperRef, setOpenWrapper);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    let type = "";
    if (value) {
      if (
        value.startsWith("bba") ||
        value.startsWith("btc") ||
        value.startsWith("eth") ||
        value.startsWith("sol") ||
        value.startsWith("ada") ||
        value.startsWith("doge") ||
        value.startsWith("dot") ||
        value.startsWith("ltc") ||
        value.startsWith("xrp") ||
        value.startsWith("xlm") ||
        value.startsWith("xmr") ||
        value.startsWith("xem") ||
        value.startsWith("xch") ||
        value.startsWith("xpr")
      ) {
        type = "token";
      } else if (/^[0-9]+$/g.test(value)) {
        type = "block";
      } else if (/[0-9]+/g.test(value) && /[a-zA-Z]+/g.test(value)) {
        type = "transaction";
      } else {
        type = "all";
      }
      setOpenWrapper(true);
    } else {
      setOpenWrapper(false);
    }
    if (type !== dropdownType) {
      setTabIndex(0);
    }
    setDropdownType(type);
  };
  return (
    <div ref={wrapperRef} className={`relative ${extra}`}>
      <input
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        className={`text-small flex w-full items-center justify-center rounded-[10px] bg-white p-3 !pr-12 outline-none dark:bg-gray-900 ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
        onChange={handleChange}
      />
      <button className="btn text-xsmall absolute right-[14px] top-[12px] !rounded !p-[2px]">
        <FiSearch />
      </button>
      {dropdownType && (
        <div
          className={`box absolute left-[0] top-[42px] z-[9999] w-full origin-top bg-gray-50 py-5 transition-all duration-300 ease-in-out dark:bg-darkGrey ${
            openWrapper ? "scale-100" : "scale-y-0"
          }`}
        >
          <div className="flex flex-wrap items-center gap-2 px-5 py-3">
            <div className="flex items-center gap-2">
              <img
                width={15}
                height={15}
                className="mb-1.5"
                src={Header}
                alt="Header"
              />
              <span className="">MoonPlay:</span>
              <span className="">Buy &Sell Crypto with a credit card.</span>
            </div>
            <span className="badge mb-1">Sponsored</span>
          </div>
          <div className="flex flex-col gap-5 border-b-[2px] border-t-[2px] border-gray-100 pb-3 pt-6 dark:border-lightGrey">
            {dropdownType === "all" ? (
              <>
                <p className="px-5 dark:text-gray-500">Trending Search</p>
                <div className="mx-5 flex items-center gap-2 border-b-[2px] border-gray-100 py-2.5 dark:border-lightGrey">
                  <img
                    width={17}
                    height={17}
                    className=""
                    src={Token}
                    alt="Logo"
                  />
                  <span>Token LINKEDIN COIN</span>
                </div>
                <div className="mx-5 flex items-center gap-2 border-b-[2px] border-gray-100 py-2.5 dark:border-lightGrey">
                  <img
                    width={17}
                    height={17}
                    className=""
                    src={Token}
                    alt="Logo"
                  />
                  <span>Token LINKEDIN COIN</span>
                </div>
                <div className="mx-5 flex items-center gap-2 border-b-[2px] border-gray-100 py-2.5 dark:border-lightGrey">
                  <img
                    width={17}
                    height={17}
                    className=""
                    src={Token}
                    alt="Logo"
                  />
                  <span>Token LINKEDIN COIN</span>
                </div>
              </>
            ) : dropdownType === "block" ? (
              <div className="flex flex-col gap-2.5">
                <div className="flex gap-2.5 border-b-[2px] border-gray-100 px-5 pb-2.5 dark:border-lightGrey">
                  <button
                    className={`btn btn-tab ${tabIndex === 0 ? "active" : ""}`}
                    onClick={() => setTabIndex(0)}
                  >
                    All (1)
                  </button>
                  <button
                    className={`btn btn-tab ${tabIndex === 1 ? "active" : ""}`}
                    onClick={() => setTabIndex(1)}
                  >
                    Block (1)
                  </button>
                </div>
                <div className="border-b-[2px] border-gray-100 px-5 py-3 dark:border-lightGrey">
                  <p className="mb-3 text-lightGrey dark:text-gray-500">
                    Block (1)
                  </p>
                  <span>415544859</span>
                </div>
                <div className="flex items-center justify-between px-5 pt-3">
                  <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                    <span className="text-xl">
                      <IoArrowUpCircleOutline />
                    </span>
                    <span className="text-xl">
                      <IoArrowDownCircleOutline />
                    </span>
                    <span>Navigate</span>
                    <span className="badge text-gray-700 dark:text-gray-300">
                      ESC
                    </span>
                    <span>Close</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                    <span className="text-xl">
                      <RxEnter />
                    </span>
                    <span>Enter</span>
                  </div>
                </div>
              </div>
            ) : dropdownType === "transaction" ? (
              <div className="flex flex-col gap-2.5">
                <div className="flex gap-2.5 border-b-[2px] border-gray-100 px-5 pb-2.5 dark:border-lightGrey">
                  <button
                    className={`btn btn-tab ${tabIndex === 0 ? "active" : ""}`}
                    onClick={() => setTabIndex(0)}
                  >
                    All (1)
                  </button>
                  <button
                    className={`btn btn-tab ${tabIndex === 1 ? "active" : ""}`}
                    onClick={() => setTabIndex(1)}
                  >
                    Transaction (1)
                  </button>
                </div>
                <div className="border-b-[2px] border-gray-100 px-5 py-3 dark:border-lightGrey">
                  <p className="mb-3 text-lightGrey dark:text-gray-500">
                    Transaction (1)
                  </p>
                  <div className="truncateWrapper">
                    <span className="truncate">
                      5yzMwTsnCLyDkJDhjmLnQRhf7TJQtsdBfMw9U5VctCP6fa6wq6whcB2G3MmdbQqvhYyNq7Zw6iAG1tuKuTKLeHPP
                    </span>
                  </div>
                </div>
                <div className="flex items-center justify-between px-5 pt-3">
                  <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                    <span className="text-xl">
                      <IoArrowUpCircleOutline />
                    </span>
                    <span className="text-xl">
                      <IoArrowDownCircleOutline />
                    </span>
                    <span>Navigate</span>
                    <span className="badge text-gray-700 dark:text-gray-300">
                      ESC
                    </span>
                    <span>Close</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                    <span className="text-xl">
                      <RxEnter />
                    </span>
                    <span>Enter</span>
                  </div>
                </div>
              </div>
            ) : dropdownType === "token" ? (
              <div className="flex flex-col gap-2.5">
                <div className="flex flex-wrap gap-2.5 border-b-[2px] border-gray-100 px-5 pb-2.5 dark:border-lightGrey">
                  <button
                    className={`btn btn-tab ${tabIndex === 0 ? "active" : ""}`}
                    onClick={() => setTabIndex(0)}
                  >
                    All (1)
                  </button>
                  <button
                    className={`btn btn-tab ${tabIndex === 1 ? "active" : ""}`}
                    onClick={() => setTabIndex(1)}
                  >
                    Token (12)
                  </button>
                  <button
                    className={`btn btn-tab ${tabIndex === 2 ? "active" : ""}`}
                    onClick={() => setTabIndex(2)}
                  >
                    Addresses (21)
                  </button>
                  <button
                    className={`btn btn-tab ${tabIndex === 3 ? "active" : ""}`}
                    onClick={() => setTabIndex(3)}
                  >
                    Program (1)
                  </button>
                  <button
                    className={`btn btn-tab ${tabIndex === 4 ? "active" : ""}`}
                    onClick={() => setTabIndex(4)}
                  >
                    Domain (1)
                  </button>
                </div>
                <div className="flex flex-col gap-3 border-b-[2px] border-gray-100 px-5 py-3 dark:border-lightGrey">
                  <p className="text-lightGrey dark:text-gray-500">
                    Tokens (12)
                  </p>
                  <div className="flex items-center gap-2 border-b-[2px] border-gray-100 py-2.5 dark:border-lightGrey">
                    <img
                      width={20}
                      height={20}
                      className=""
                      src={BBA}
                      alt="BBA"
                    />
                    <span>BBA (BBA)</span>
                  </div>
                  <div className="flex items-center gap-2 border-b-[2px] border-gray-100 py-2.5 dark:border-lightGrey">
                    <img
                      width={20}
                      height={20}
                      className=""
                      src={BTC}
                      alt="BTC"
                    />
                    <span>Bitcoin (BTC)</span>
                  </div>
                </div>
                <div className="flex items-center justify-between px-5 pt-3">
                  <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                    <span className="text-xl">
                      <IoArrowUpCircleOutline />
                    </span>
                    <span className="text-xl">
                      <IoArrowDownCircleOutline />
                    </span>
                    <span>Navigate</span>
                    <span className="badge text-gray-700 dark:text-gray-300">
                      ESC
                    </span>
                    <span>Close</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                    <span className="text-xl">
                      <RxEnter />
                    </span>
                    <span>Enter</span>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchField;
